import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ConfirmedPage from "@/pages/ConfirmedPage";
import { Show } from "@clerk/react";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import AuthPage from "@/pages/AuthPage";
import QuotesPage from "@/pages/QuotesPage";
import QuoteEditor from "@/pages/QuoteEditor";
import CatalogPage from "@/pages/CatalogPage";
import ClientsPage from "@/pages/ClientsPage";
import UsersPage from "@/pages/UsersPage";
import SettingsPage from "@/pages/SettingsPage";

const Protected = () => (
  <>
    <Show when="signed-in"><Layout /></Show>
    <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
  </>
);

function App() {
  return (
    <div className="App dark">
      <BrowserRouter>
        <ClerkAuthProvider>
          <Routes>
            <Route path="/sign-in/*" element={<AuthPage mode="in" />} />
            <Route path="/sign-up/*" element={<AuthPage mode="up" />} />
            <Route element={<Protected />}>
              <Route path="/" element={<QuotesPage />} />
              <Route path="/preventivi/nuovo" element={<QuoteEditor />} />
              <Route path="/preventivi/:id" element={<QuoteEditor />} />
              <Route path="/catalogo" element={<CatalogPage />} />
              <Route path="/clienti" element={<ClientsPage />} />
              <Route path="/utenti" element={<UsersPage />} />
              <Route path="/confermati" element={<ConfirmedPage />} />
              <Route path="/impostazioni" element={<SettingsPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </ClerkAuthProvider>
        <Toaster theme="dark" position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
